import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=1f5edbb5&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5edbb5",
  null
  
)

export default component.exports